import Cookies from 'js-cookie';

const DISMISSED_ALERTS_COOKIE_KEY = 'dismissed_alerts';
const COOKIE_EXPIRY_DAYS = 365; // Store for 1 year

// Check if we're in a browser environment
const isBrowser = typeof window !== 'undefined';

export function getDismissedAlertsCookie(): string[] {
  if (!isBrowser) return [];

  try {
    const dismissedAlerts = Cookies.get(DISMISSED_ALERTS_COOKIE_KEY);
    return dismissedAlerts ? JSON.parse(dismissedAlerts) : [];
  } catch (error) {
    console.error('Error reading dismissed alerts cookie:', error);
    return [];
  }
}

export function addDismissedAlertCookie(alertId: string): void {
  if (!isBrowser) return;

  try {
    const dismissedAlerts = getDismissedAlertsCookie();
    if (!dismissedAlerts.includes(alertId)) {
      dismissedAlerts.push(alertId);
      Cookies.set(DISMISSED_ALERTS_COOKIE_KEY, JSON.stringify(dismissedAlerts), {
        expires: COOKIE_EXPIRY_DAYS,
        sameSite: 'strict'
      });
    }
  } catch (error) {
    console.error('Error setting dismissed alert cookie:', error);
  }
}

export function removeDismissedAlertCookie(alertId: string): void {
  if (!isBrowser) return;

  try {
    const dismissedAlerts = getDismissedAlertsCookie();
    const updatedAlerts = dismissedAlerts.filter(id => id !== alertId);
    Cookies.set(DISMISSED_ALERTS_COOKIE_KEY, JSON.stringify(updatedAlerts), {
      expires: COOKIE_EXPIRY_DAYS,
      sameSite: 'strict'
    });
  } catch (error) {
    console.error('Error removing dismissed alert cookie:', error);
  }
}

export function clearDismissedAlertsCookie(): void {
  if (!isBrowser) return;

  try {
    Cookies.remove(DISMISSED_ALERTS_COOKIE_KEY);
  } catch (error) {
    console.error('Error clearing dismissed alerts cookie:', error);
  }
}
